import { Component, inject, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';

@Component({
  selector: 'app-manufacturer-profile',
  imports: [],
  templateUrl: './manufacturer-profile.component.html',
  styleUrl: './manufacturer-profile.component.scss',
})
export class ManufacturerProfileComponent {
  @Input() email: string = '';

  public popoverCtrl = inject(PopoverController);
  private authService = inject(AuthService);

  user: any;
  supplier: any;

  ngOnInit() { 
    this.user = this.authService.currentUserValue;
    console.log('User popover:', this.user); 
  }

  changePassword() {
    this.popoverCtrl.dismiss('password');
  }

  logout() {
    this.popoverCtrl.dismiss('logout');
  }

}
